const getAttributeValue = (variation, attributeName) => {
  if (!variation.variationAttributeValues) return "";
  if (!variation.variationAttributeValues.length) return "";
  let attribute = variation.variationAttributeValues.find((attribute) => attribute.attribute.backendName === attributeName);
  if (!attribute) return "";
  return attribute.attributeValue.backendName.replaceAll("_", " ");
};

const getVariationsByAttributeType = (setData, attributeName) => {
  let components = setData.components.filter((component) =>
    component.item.variations.some((variation) =>
      variation.variationAttributeValues.some((value) => value.attribute.backendName === attributeName)
    )
  );

  if (!components[0]) return [];
  let variations = [];

  if (components.length > 1) {
    for (const component of components) {
      variations = [...variations, ...component.item.variations.filter((variation) => !variation.isMain)]; 
    }

    return variations;
  }

  variations = components[0].item.variations.filter((variation) => !variation.isMain);

  if (variations) return variations;
  return [];
};

const getItemByVariationNumberPrefix = (items, prefix) => {
  let match = items.find((item) =>
    item.variations.some((variation) => variation.number.includes(prefix))
  );

  return match;
};

const getItemName = (item) => {
  if (!item.texts) return "";
  return item.texts[0].name1;
}

const getPrice = (variation) => {
  return variation?.variationSalesPrices?.[0]?.price;
}


export { getAttributeValue, getVariationsByAttributeType, getItemByVariationNumberPrefix, getItemName ,getPrice };
